module.exports = __webpack_public_path__ + "static/media/eu.4c73f57c.svg";